<reader-settings-window
  [isVisible]="showSettingsWindow"
  (closeWindow)="onSettingsWindowHide()"
  (goToBookmarkClicked)="goToBookmark($event)"
  (exportButtonClicked)="onExportButtonClicked($event)"
  [(gapLevel)]="gap"
  [(mode)]="mode"
  [(downloadMod)]="downloadMod"
>
</reader-settings-window>

<div class="reader-container-wrapper">
  <reader-hud
    [currentPage]="currentPageNumber()"
    [totalPages]="currentPageTotal()"
    [chapterOrder]="currentChapterOrder()"
    [bookmarked]="currentPageBookmarked()"
    [bookmarkPending]="bookmarkPending()"
    (bookmarkClicked)="toggleCurrentPageBookmark()"
    (settingsClicked)="openReaderSettings()">
  </reader-hud>

  <manga-reader></manga-reader>
</div>